import { Environment, baseEnv } from './environment.base';

export const ticketsfyEnv = Object.assign(baseEnv, {
  seatsioWorkSpaceKey: 'c9cec1b9-4392-4810-9a38-722217795db6',
  platformConfigs: [
    {
      domain: 'tickets.ticketsfy.net',
      api: 'https://api.ticketsfy.net/api/v2',
      token: 'RAjltv4Zxh3e',
    },
    {
      domain: 'tickets.doremi.art',
      api: 'https://api.doremi.art/api/v2',
      token: 'QitaShGAwxpl',
    },
    {
      domain: 'tickets.ticketsfy.mu',
      api: 'https://api.ticketsfy.mu/api/v2',
      token: '2oX5VLwe3Z0c',
    },
  ],
  modules: ['discounts'],
  paymentSetup: {
    taxNumberInputLabel: 'UAE Tax Registration Number',
    taxNumberRequiredMin: 10000,
  },
  stripeKey:
    'pk_live_51J7ajwH5Xks8TpTwP63YHH6pn9acYCAVx6kIJ89Hes7bPYNuAH0zuX9cnNam5x2h3qNRla8Imn2BUNMxL2YQ8XNl00GZFLqIAN',
  profileFields: ['nationality'],
});

export const environment: Environment = ticketsfyEnv;
